import { useCallback } from 'react';
import { CustomButton } from '../../../components/CustomButton';
import RModal from '../../../components/Rsuite/Modal';
import { useAuth } from '../../../hooks/auth';
import api from '../../../services/api';
import { toastSuccess, toastWarning, toastError } from '../../../toasts';

const ConcluirTodos = ({ open, close, status, pedidos }) => {
  const { id_empresa } = useAuth();

  const handleConcludeAll = useCallback(async () => {
    if(!pedidos || pedidos.length === 0) {
      toastWarning('Não há pedidos', 'Aviso');
      close();
      return;
    }

    await api
      .post('pedido/concluirTodos', {
        IdEmpresa: id_empresa,
        Status: status,
      })
      .then((res) => {
        if (res.data) {
          toastSuccess('Pedidos concluídos.', 'Sucesso');
          close();
          setInterval(() => {
            window.location.reload();
          }, [1000]);
        } else {
          toastWarning('Não há pedidos', 'Aviso');
        }
      })
      .catch(() => toastError('Não foi possivel alterar os pedidos'));
  }, [id_empresa, status, close, pedidos]);

  return (
    <RModal
      open={open}
      onClose={close}
      title={'Concluir Todos'}
      footer={
        <>
          <CustomButton onClick={handleConcludeAll} appearance="primary">
            Concluir
          </CustomButton>
          <CustomButton onClick={close} appearance="ghost">
            Fechar
          </CustomButton>
        </>
      }
    >
      <div>
        Deseja concluir todos os pedidos da lista <b>"{status}"</b> ?
      </div>
    </RModal>
  );
};

export default ConcluirTodos;
